import * as React from 'react';
import { ISubcardsSearchSelectProps } from './types';
import { CARD_SUBCARD_CREATE, CARD_SUBCARD_CREATE_FOOTER, CARD_SUBCARD_SEARCH } from './constants';
import { CardSubcardsAdd } from '../CardSubcardsAdd/CardSubcardsAdd';
import { SearchSelect } from '../../../../../base/components/SearchSelect/SearchSelect';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
import { SelectListItem } from 'kui';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`SubcardsSearchSelect`) : null;

export function SubcardsSearchSelect({
    availableElements,
    isOpened,
    isPopup,
    onAdd,
    onAddClosed,
    onCreate,
}: ISubcardsSearchSelectProps ) {
    if (analyzeRender) analyzeRender.call(`SubcardsSearchSelect`);
    return (
        <SearchSelect
            createFooter={CARD_SUBCARD_CREATE_FOOTER}
            isCloseOnClick={false}
            isCloseOnEnter={false}
            isFitWindow={isPopup}
            isDropdownUplifted={!isPopup}
            opened={isOpened}
            options={availableElements}
            option={CardSubcardsAdd}
            onBlur={onAddClosed}
            onClosed={ onAddClosed }
            onSelect={(cardId) => onAdd(Number(cardId))}
            onCreate={onCreate}
            placeholder={CARD_SUBCARD_SEARCH}
        />
    );
};
